import axios from "axios";
import { getAPIBaseUrl } from "../utils/constants";

export const getAssets = async () => {
  const apiUrl = getAPIBaseUrl();
  return await axios.get(`${apiUrl}/get_logo`);
};
